import styled from 'styled-components';
import { Link } from "gatsby";
import media from "styled-query";

export const Container = styled.footer`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--gray);
`;

export const ContainerInfo = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  background: #252525;
  justify-content: center;
`;

export const DivInfo = styled.div`
  display: flex;
  width: 100%;
  max-width: 1120px;  
  padding: 20px;
  justify-content: center;
  ${media.lessThan("700px")`
    flex-direction: column;
    text-align: center;
  `}
`;

export const Info = styled.span`
  color: white;
  margin: 0 15px;
  ${media.lessThan("700px")`
    margin-bottom: 15px;
  `}
`;

export const NavFooter = styled.nav`
  display: flex;
  color: white;
  justify-content: center;
  ${media.lessThan("550px")`
    flex-direction: column;
  `}
`;

export const NavLink = styled(Link)`
  color: white;
  margin: 0 15px;
`;